import {Center} from '@mantine/core'
import React from 'react'
import type {ReactElement} from 'react'
import type {Sx} from '@mantine/core'

interface Options {
  children: ReactElement
}

const styles: Record<string, Sx> = {
  container: {
    height: '100vh',
  },
}

// Fills the page with content.
export default function FullPage({children}: Options): ReactElement {
  return <Center sx={styles.container}>{children}</Center>
}
